export const ENDPOINTS = {
    ONLINE_PROCESSES: '/api/online-processes',
    REAL_ESTATE: '/api/real-estate',
    PURCHASE_ORDERS: '/api/purchase-orders',
    DOCUMENTS: '/api/documents'
};